import { rem } from 'polished';
import styled from 'styled-components';
import { DESKTOP_HEADER_HEIGHT, MOBILE_HEADER_HEIGHT } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    display: flex;
    padding: ${rem(40)} ${rem(20)};
    max-width: ${rem(1180)};
    margin: ${rem(MOBILE_HEADER_HEIGHT)} auto ${rem(40)} auto;
    min-height: ${rem(500)};
    flex-direction: column-reverse;

    @media (min-width: ${breakpoints.sm}px) {
        margin: ${rem(DESKTOP_HEADER_HEIGHT)} auto ${rem(40)} auto;
    }

    @media (min-width: ${breakpoints.md}px) {
        flex-direction: row;
        align-items: center;
        padding: 0;
    }
`;

export const Label = styled.span`
    font-size: ${({ theme }) => theme.fontSizes.h6};
    line-height: ${rem(26)};
    display: flex;
    margin-bottom: ${rem(14)};

    svg {
        width: ${rem(22)};
        height: ${rem(22)};
        margin-right: ${rem(8)};
        margin-top: ${rem(2)};

        polyline {
            stroke: black;
        }
    }
`;

export const Image = styled.img`
    width: 100%;
    border-radius: ${rem(10)};
    height: auto;
    margin-top: ${rem(30)};

    @media (min-width: ${breakpoints.md}px) {
        display: block;
        margin-top: ${rem(0)};
        width: ${rem(600)};
    }
`;

export const About = styled.div`
    @media (min-width: ${breakpoints.md}px) {
        padding-left: ${rem(65)};
    }
`;

export const Title = styled.h1`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h3};
    font-family: ${({ theme }) => theme.fonts.fontSecondary};
    padding-bottom: ${rem(30)};

    @media (min-width: ${breakpoints.md}px) {
        font-size: ${({ theme }) => theme.fontSizes.h2};
    }
`;

export const Description = styled.h3`
    font-size: ${({ theme }) => theme.fontSizes.h6};
    font-weight: ${({ theme }) => theme.fontWeights.textRegular};
    padding: ${rem(15)} 0 ${rem(25)} 0;
    line-height: ${rem(30)};
    color: ${({ theme }) => theme.colors.grey};
`;
